import { cookies } from './modules/Vars';
import { getCookie, setCookie, deleteCookies } from './modules/Cookies';

var newUser = false;

document.addEventListener('DOMContentLoaded', function(){
    var cookieName = $('#popupCookie').data('name');
    var cookieExpire = $('#popupCookie').data('expire');
    var $lastPage;

    if (!(getCookie('hbd-cookie-settings'))) {
        deleteCookies();
        newUser = true;
    } else {
        syncCookiesAndSettings();
    }
    if ($('#popupCookie').length && !$('#popupCookie').hasClass('hidden')) {
        trackPixel('pageload');
    }
    $('#popupCookie').on('show.bs.collapse hide.bs.collapse', function(e) {
        let $link = $('[href="#' + e.target.id + '"]');
        $link.find('i').toggleClass('icon-arrow_down').toggleClass('icon-arrow_up')
    });

    $('.cookieSubmitAll').click(function() {
        trackPixel('submit_all');
        storeReferrer();
        setCookie(cookieName, JSON.stringify(cookies), cookieExpire);
        location.reload();
    });

    $('.cookieSubmitNone').click(function() {
        trackPixel('submit_none');
        cookies['GTM'] = false;
        cookies['HOTJAR'] = false;
        cookies['RECAPTCHA'] = false;
        cookies['ADSENSE'] = false;
        cookies['YEXT'] = false;
        setCookie(cookieName, JSON.stringify(cookies), cookieExpire);
        $('#popupCookie').addClass('hidden')
    });

    $('#cookieSubmitSettings').click(function() {
        if (newUser) { // new User
/*
            var allowed = [0,0,0];
            allowed[0] = $('#cookiesGTM').is(":checked") ? 'T' : '-';
            allowed[1] = $('#cookiesHotjar').is(":checked") ? 'H' : '-';
            allowed[2] = $('#cookiesReCaptcha').is(":checked") ? 'V' : '-';
            trackPixel('submit_' + allowed.join(''));
*/
            cookies['GTM'] = $('#cookiesGTM').is(":checked");
            cookies['HOTJAR'] = $('#cookiesHotjar').is(":checked");
            cookies['RECAPTCHA'] = $('#cookiesReCaptcha').is(":checked");
            cookies['ADSENSE'] = $('#cookiesAdsense').is(":checked");
            cookies['YEXT'] = $('#cookiesYext').is(":checked");
            storeReferrer();
            setCookie(cookieName, JSON.stringify(cookies), cookieExpire);
            location.reload();
        } else { // user changed settings
            cookies['GTM'] = $('#cookiesGTM').is(":checked");
            cookies['HOTJAR'] = $('#cookiesHotjar').is(":checked");
            cookies['RECAPTCHA'] = $('#cookiesReCaptcha').is(":checked");
            cookies['ADSENSE'] = $('#cookiesAdsense').is(":checked");
            cookies['YEXT'] = $('#cookiesYext').is(":checked");
            var oldCookies = JSON.parse(getCookie('hbd-cookie-settings'));
            if (JSON.stringify(cookies) !== JSON.stringify(oldCookies)) {
                setCookie(cookieName, JSON.stringify(cookies), cookieExpire);
                setCookie('hbd-cookie-changed', 'true', cookieExpire);
                location.reload();
            } else {
                $('#popupCookie').addClass('hidden')
            }
        }
    });

    $('.linkCookieSettings').click(function() {
        if ($('#popupCookie').hasClass('hidden')) { // only if opened using the link in the footer
            $('.popupContent').addClass('hidden');
            $('.popupContent.cookieSettings').removeClass('hidden');
            $('#popupCookie').removeClass('hidden');
        }
        $('#popupCookie .inner').scrollTop(0);
        $lastPage = $('.popupContent:not(.hidden)');
        $('.popupContent').addClass('hidden');
        $('.cookieSettings').removeClass('hidden');
    });

    $('.cookieSettings li .checker :checkbox').on('click', function () {
        // check/uncheck all children
        var that=this;
        var query = $(this).closest('li');
        if ($(this).closest('li').hasClass('master')) {
            query = $('.cookieSettings');
        }
        query.find('li:not(.disabled) > .checker :checkbox').each(
            function() {
                $(this).prop('checked', $(that).prop('checked'));
            }
        );
        // check/uncheck all parents
        checkParents();
    });

    $('#acceptReCaptcha').click(function() {
        $('#cookiesReCaptcha').prop('checked', true);
        $('#cookieSubmitSettings').click();
    });
});

function syncCookiesAndSettings() {
    var currentSettings = JSON.parse(getCookie('hbd-cookie-settings'));
    if (currentSettings['GTM']) {
        $('#cookiesGTM').trigger('click');
    }
    if (currentSettings['HOTJAR']) {
        $('#cookiesHotjar').trigger('click');
    }
    if (currentSettings['RECAPTCHA']) {
        $('#cookiesReCaptcha').trigger('click');
    }
    if (currentSettings['ADSENSE']) {
        $('#cookiesAdsense').trigger('click');
    }
    if (currentSettings['YEXT']) {
        $('#cookiesYext').trigger('click');
    }
    checkParents();
}

function checkParents() {
    var allCheckMaster = true;
    $('.cookieSettings li.main:not(.disabled)').each( function() {
        var allCheckedMain = true;
        $(this).find('li .checker :checkbox').each( function() {
            allCheckedMain = allCheckedMain && $(this).prop('checked');
        });
        $(this).find('> .checker :checkbox').prop('checked', allCheckedMain);
        allCheckMaster = allCheckMaster && allCheckedMain;
    });
    $('.cookieSettings li.master > .checker :checkbox').prop('checked', allCheckMaster);
}
function storeReferrer() {
    sessionStorage.setItem("referrer", document.referrer);
}

function trackPixel(pixel) {
    if (newUser) {
        $('#cookieTrackPx').attr("src","/global/images/cookiePixels/" + pixel + ".gif");
    }
}